'use client'
import{jsx as e}from"react/jsx-runtime";var o=({htmlFor:t,label:l})=>e("label",{htmlFor:t,className:"ui-block ui-text-lg  ui-font-bold ui-leading-6 ui-text-gray-900",children:l}),a=o;export{a};
